









































import { useDep } from '~/compositions/dependency-container'
import { useRequestError } from '~/compositions/request-error'
import ClassifiedSearchService from '~/services/search/ClassifiedSearchService'
import { formatNumber } from '~/utils/number'
import { defineNuxtComponent, onMounted, ref } from '~/utils/nuxt3-migration'

export default defineNuxtComponent({
  setup() {
    const classifiedSearchService = useDep(ClassifiedSearchService)
    const handleRequestError = useRequestError()

    const popularDestinations = ref([])
    const loading = ref(false)

    onMounted(async () => {
      loading.value = true
      try {
        const {
          quickSearches
        } = await classifiedSearchService.getRentalsPopularSearches()
        popularDestinations.value = quickSearches
      } catch (error) {
        handleRequestError(error)
      } finally {
        loading.value = false
      }
    })

    return {
      loading,
      popularDestinations,
      formatNumber
    }
  }
})
